import React from "react";
import Webmenu from "../../layouts/webmenu";
import Topbar from "../../layouts/topbar";
import { ThreeDots } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { styleSelect } from "../../constants/customStyles";
import { useNavigate } from "react-router-dom";
import CreatableSelect from 'react-select/creatable';
import Select from 'react-select';
import { useEffect } from "react";
import { getAllState, saveState } from "../../actions/StateAction";
import { getAllVehicleCode, saveVehicleCode } from "../../actions/VehicleCodeActions";
import { getAllVehicleType, saveVehicleType } from "../../actions/VehicleTypeActions";
import { getAllVehicleMake, saveVehicleMake } from "../../actions/VehicleMakeActions";
import { getAllVehicleModel, getVehicleModelByMakeId, saveVehicleModel } from "../../actions/VehicleModelActions";
import { getAllColor, saveColor } from "../../actions/ColorActions";
import { useState } from "react";
import { getAllReplaceableVehicle } from "../../actions/ReplaceableVehicleActions";
import { getAllDriver } from "../../actions/DriverActions";
import { getAllLeasePlan, saveVehicleReplacement } from "../../actions/VehicleReplacementsActions";
import Toast from "../../components/Toast";
import { getAllInsuranceCompany } from "../../actions/InsuranceCompanyActions";
import Mobilemenu from "../../layouts/mobile-menu";

function AddReplacementOfVehicle() {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [plateNo, setPlateNo] = useState('');
    const [chasisNo, setChasisNo] = useState('');
    const [regExpiry, setRegExpiry] = useState('');
    const [stateId, setStateId] = useState('');
    const [color, setColor] = useState('');
    const [vehicleCode, setVehicleCode] = useState('');
    const [vehicleType, setVehicleType] = useState('');
    const [vehicleMake, setVehicleMake] = useState('');
    const [vehicleModel, setVehicleModel] = useState('');
    const [replacedVehicle, setReplacedVehicle] = useState('');
    const [driver, setDriver] = useState('');
    const [kmIn, setKmIn] = useState('');
    const [kmOut, setKmOut] = useState('');
    const [fuel, setFuel] = useState('');
    const [type, setType] = useState('');
    const [leaseCompany, setLeaseCompany] = useState('');
    const [customerName, setCustomerName] = useState('');
    const [customerMobile, setCustomerMobile] = useState('');

    useEffect(() => {
            dispatch(getAllState(null, 9999));
            dispatch(getAllColor(null, 9999));
            dispatch(getAllVehicleCode(null, 9999));
            dispatch(getAllVehicleType(null, 9999));
            dispatch(getAllVehicleMake(null, 9999));
            dispatch(getAllVehicleModel(null, 9999));
            dispatch(getAllReplaceableVehicle(null, 9999));
            dispatch(getAllDriver(null, 9999));
            dispatch(getAllInsuranceCompany(null, ''));
         }, []);

    const state = useSelector(state => state?.state?.states?.data);
    const colors = useSelector(state => state?.color?.colors?.data);
    const vehicleTypes = useSelector(state => state?.vehicleType?.vehicleTypes?.data);
    const vehicleMaker = useSelector(state => state?.vehicleMaker?.vehicleMakers?.data);
    const vehicleCodes = useSelector(state => state?.vehicleCode?.vehicleCodes?.data);
    const vehicleModels = useSelector(state => state?.vehicleModel?.vehicleModels?.data);
    const replaceableVehicles = useSelector(state => state?.replaceableVehicles?.replaceableVehicles?.data);
    const drivers = useSelector(state => state?.drivers?.drivers);
    const insuranceCompanies = useSelector(state => state?.insuranceCompany?.insuranceCompanies?.data);
    // 'dricers',drivers)
    const loading = useSelector(state => state?.loading?.loading);
    const FuelOptions = [
        { label: '1/3', value: '1/3' },
        { label: '1/2', value: '1/2' },
        { label: '3/4', value: '3/4' },
        { label: 'E', value: 'E' },
    ]
    const handleChangeState = (e) => {
        setStateId({
            state_id: e.state_id,
            name: e.name
        })
    }
    const handleChangeVehicleCode = (e) => {
        setVehicleCode({
            vehicle_code_id: e.vehicle_code_id,
            name: e.name
        })
    }
    const handleChangeColor = (e) => {
        setColor({
            color_id: e.color_id,
            name: e.name
        })
    }
    const handleChangeVehicleType = (e) => {
        setVehicleType({
            vehicle_type_id: e.vehicle_type_id,
            name: e.name
        })
    }
    const handleChangeVehicleMake = (e) => {
        setVehicleMake({
            vehicle_make_id: e.vehicle_make_id,
            name: e.name
        })
        dispatch(getVehicleModelByMakeId(e.vehicle_make_id));
    }
    const vehicleModelByMakeId = useSelector(state => state?.vehicleModel?.VehicleModelByMake)

    const [vehicleModelOptions, setVehicleModelOptions] = useState('');

    useEffect(() => {
        if (vehicleModelByMakeId && vehicleModelByMakeId.length > 0) {
            setVehicleModelOptions(vehicleModelByMakeId)
        } else {
            setVehicleModelOptions(vehicleModels)
        }
    }, [vehicleModelByMakeId, vehicleModels])

    const handleChangeVehicleModel = (e) => {
        setVehicleModel({
            vehicle_model_id: e.vehicle_model_id,
            name: e.name
        })
    }

    const [isLoading, setIsLoading] = useState(false);

    const handleCreateState = (inputValue) => {
        // inputValue)
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveState(data));
            dispatch(getAllState(null, 9999));
        }, 1000);
    }
    const handleCreateVehicleCode = (inputValue) => {
        // inputValue)
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveVehicleCode(data));
            dispatch(getAllVehicleCode(null, 9999));
        }, 1000);
    }
    const handleCreateVehicleType = (inputValue) => {
        // inputValue)
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            dispatch(saveVehicleType(data))
            dispatch(getAllVehicleType(null, 9999));
        }, 1000);
    }
    const handleCreateVehicleMake = (inputValue) => {
        // inputValue)
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveVehicleMake(data))
            dispatch(getAllVehicleMake(null, 9999))
        }, 1000);
    }
    const handleCreateVehicleModel = (inputValue) => {
        // inputValue)
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveVehicleModel(data));
            dispatch(getAllVehicleModel(null, 9999));
        }, 1000);
    }
    const handleCreateVehicleColor = (inputValue) => {
        // inputValue)
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveColor(data));
            dispatch(getAllColor(null, 9999));
        }, 1000);
    }
    const handleChangeReplacedVehicle = (e) => {
        setReplacedVehicle({
            replaceable_vehicle_id: e.replaceable_vehicle_id,
            name: e.plate_number,
        });
    };
    const handleChangeDriver = (e) => {
        setDriver({
            driver_id: e.id,
            name: e.driver_name,
        });
    };
    const handleChangeLeaseCompanies = (e) => {
        setLeaseCompany({
            value: 81,
            label: 'Lease Plan',
        });
    };
    const handleChangeFuelOption = (e) => {
        setFuel({
            value: e.value,
            label: e.label,
        });
    };

    const save = () => {
        if (plateNo.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Plate No is Required!'
            })
        } else if (customerName.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Customer Name is Required!'
            })
        } else if (customerMobile.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Customer Mobile is Required!'
            })
        } else if (chasisNo.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Chasis No is Required!'
            })
        } else if (regExpiry.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Reg. Expiry is Required!'
            })
        } else if (vehicleCode.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Code is Required!'
            })
        } else if (vehicleType.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Type is Required!'
            })
        } else if (vehicleMake.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Make is Required!'
            })
        } else if (vehicleModel.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Model is Required!'
            })
        } else if (replacedVehicle.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Replacement Vehicle is Required!'
            })
        } else if (driver.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Driver is Required!'
            })
        } else {
            let data = {
                company_id: 81,
                customer_name: customerName,
                customer_mobile: customerMobile,
                plate_number: plateNo,
                chasis_no: chasisNo,
                registration_expiry: regExpiry,
                state_id: stateId?.state_id,
                code_id: vehicleCode?.vehicle_code_id,
                color_id: color?.color_id,
                vehicle_type_id: vehicleType?.vehicle_type_id,
                vehicle_make_id: vehicleMake?.vehicle_make_id,
                vehicle_model_id: vehicleModel?.vehicle_model_id,
                fuel: fuel?.label,
                type: type,
                km_in: kmIn,
                km_out: kmOut,
                replaceable_vehicle_id: replacedVehicle?.replaceable_vehicle_id,
                driver_id: driver?.driver_id,
            }
            dispatch(saveVehicleReplacement(data, navigate));
        }
    }
    return (
        <React.Fragment>
            <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />
                    {
                        loading ?
                            <ThreeDots
                                height="80"
                                width="80"
                                radius="9"
                                color="#2d3748"
                                ariaLabel="three-dots-loading"
                                wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                                wrapperClassName=""
                                visible={loading}
                            /> :
                            <span>
                                <div className="intro-y d-flex align-items-center mt-3">
                                    <h2 className="fs-lg fw-medium me-auto">
                                        Replacement Of Vehicle
                                    </h2>
                                </div>
                                <div className="intro-y d-flex align-items-center mt-5">
                                    <h2 className="fs-base fw-medium me-auto ms-5">
                                        Customer Info
                                    </h2>
                                </div>
                                {/* <!-- BEGIN: Form Layout --> */}
                                <div className="intro-y box p-5 mt-3">
                                    <div className="grid columns-12">
                                        <div className="intro-y g-col-12 g-col-sm-4 z-10">
                                            <label htmlFor="contractor" className="form-label">
                                                Company :
                                            </label>
                                            {/* <Select
                                                value={leaseCompany}
                                                onChange={(e) => handleChangeLeaseCompanies(e)}
                                                getOptionLabel={(option) => `${option.name}`}
                                                getOptionValue={(option) => `${option.insurance_company_id}`}
                                                options={insuranceCompanies && insuranceCompanies.length > 0 ? insuranceCompanies : []}
                                                styles={styleSelect}
                                                placeholder="Please Select Type"
                                            /> */}
                                            <Select
                                                value={{ value: 81, label: 'Lease Plan' }}
                                                onChange={(e) => handleChangeLeaseCompanies(e)}
                                                options={[{ value: 81, label: 'Lease Plan' }]}
                                                isDisabled={true}
                                                // getOptionLabel={(option) => `${option.name}`}
                                                // getOptionValue={(option) => `${option.insurance_company_id}`}
                                                // options={insuranceCompanies && insuranceCompanies.length > 0 ? insuranceCompanies : []}
                                                styles={styleSelect}
                                                name=""
                                            />
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Customer Mobile <span className="text-theme-6">*</span> :</label>
                                            <input id="crud-form-1" onChange={(e) => setCustomerMobile(e.target.value)} type="text" className="form-control w-full" placeholder="Enter Customer Mobile" />
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Customer Name <span className="text-theme-6">*</span> :</label>
                                            <input id="crud-form-1" onChange={(e) => setCustomerName(e.target.value)} type="text" className="form-control w-full" placeholder="Enter Customer Name" />
                                        </div>
                                        {/* <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Service Expiry<span className="text-theme-6">*</span> :</label>
                                            <input id="crud-form-1" type="date" className="form-control w-full" />
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Service Mile<span className="text-theme-6">*</span> :</label>
                                            <input id="crud-form-1" type="text" className="form-control w-full" placeholder="Enter Service Mile" />
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">State<span className="text-theme-6">*</span> :</label>
                                            <Select styles={styleSelect} name="" />
                                        </div> */}
                                    </div>
                                </div>
                                {/* <!-- BEGIN: Form Layout --> */}
                                <div className="intro-y d-flex align-items-center mt-3">
                                    <h2 className="fs-base fw-medium me-auto ms-5">
                                        Customer Vehicle Info
                                    </h2>
                                </div>
                                <div className="intro-y box p-5 mt-3">
                                    <div className="grid columns-12">
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Vehicle Plate No. <span className="text-theme-6">*</span> :</label>
                                            <input id="crud-form-1" type="text" onChange={(e) => setPlateNo(e.target.value)} className="form-control w-full" placeholder="Enter Plate No." />
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Vehicle Chasis No. <span className="text-theme-6">*</span> :</label>
                                            <input id="crud-form-1" type="text" onChange={(e) => setChasisNo(e.target.value)} className="form-control w-full" placeholder="Enter Chasis No." />
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Vehicle Reg Expiry <span className="text-theme-6">*</span> :</label>
                                            <input id="crud-form-1" type="date" onChange={(e) => setRegExpiry(e.target.value)} className="form-control w-full" placeholder="Enter Reg Expiry" />
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">State :</label>
                                            <CreatableSelect formatCreateLabel={() => "Create New.."} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                                isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateState} styles={styleSelect}
                                                onChange={(e) => handleChangeState(e)} getOptionLabel={(option) => `${option.name}`}
                                                getOptionValue={(option) => `${option.state_id}`} options={state && state.length > 0 ? state : []} />
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Color :</label>
                                            <CreatableSelect formatCreateLabel={() => "Create New.."} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                                isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateVehicleColor} styles={styleSelect}
                                                onChange={(e) => handleChangeColor(e)} getOptionLabel={(option) => `${option.name}`}
                                                getOptionValue={(option) => `${option.color_id}`} options={colors && colors.length > 0 ? colors : []} />
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Vehicle Code<span className="text-theme-6">*</span> :</label>
                                            <CreatableSelect formatCreateLabel={() => "Create New.."} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                                isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateVehicleCode} styles={styleSelect}
                                                onChange={(e) => handleChangeVehicleCode(e)} getOptionLabel={(option) => `${option.name}`}
                                                getOptionValue={(option) => `${option.vehicle_code_id}`} options={vehicleCodes && vehicleCodes.length > 0 ? vehicleCodes : []} />
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Vehicle Type<span className="text-theme-6">*</span> :</label>
                                            <CreatableSelect formatCreateLabel={() => "Create New.."} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                                isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateVehicleType} styles={styleSelect}
                                                onChange={(e) => handleChangeVehicleType(e)} getOptionLabel={(option) => `${option.name}`}
                                                getOptionValue={(option) => `${option.vehicle_type_id}`} options={vehicleTypes && vehicleTypes.length > 0 ? vehicleTypes : []} />
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Vehicle Make<span className="text-theme-6">*</span> :</label>
                                            <CreatableSelect formatCreateLabel={() => "Create New.."} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                                isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateVehicleMake} styles={styleSelect}
                                                onChange={(e) => handleChangeVehicleMake(e)} getOptionLabel={(option) => `${option.name}`}
                                                getOptionValue={(option) => `${option.vehicle_make_id}`} options={vehicleMaker && vehicleMaker.length > 0 ? vehicleMaker : []} />
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Vehicle Model<span className="text-theme-6">*</span> :</label>
                                            <CreatableSelect formatCreateLabel={() => "Create New.."} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                                isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateVehicleModel} styles={styleSelect}
                                                onChange={(e) => handleChangeVehicleModel(e)} getOptionLabel={(option) => `${option.name}`}
                                                getOptionValue={(option) => `${option.vehicle_model_id}`} options={vehicleModelOptions && vehicleModelOptions.length > 0 ? vehicleModelOptions : []} />
                                        </div>
                                    </div>
                                </div>
                                <div className="intro-y d-flex align-items-center mt-3">
                                    <h2 className="fs-base fw-medium me-auto ms-5">
                                        Replacement Vehicle Info
                                    </h2>
                                </div>
                                <div className="intro-y box p-5 mt-3">
                                    <div className="grid columns-12">
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Replacement Vehicle <span className="text-theme-6">*</span> :</label>
                                            <Select styles={styleSelect} getOptionLabel={(option) => `${option.plate_number}`} onChange={(e) => handleChangeReplacedVehicle(e)}
                                                getOptionValue={(option) => `${option.vehicle_id}`} options={replaceableVehicles && replaceableVehicles.length > 0 ? replaceableVehicles : []} />
                                        </div>
                                        <div class="g-col-12 g-col-md-4 mt-3"> <label>Type :</label>
                                            <div class="d-flex flex-coloumn flex-sm-row mt-2">
                                                <div class="form-check me-2"> <input id="radio-switch-4" class="form-check-input" type="radio" onChange={(e) => setType(e.target.value)} checked={type === "dedicated"} name="horizontal_radio_button" value="dedicated" /> <label class="form-check-label" for="radio-switch-4">Dedicated</label> </div>
                                                <div class="form-check me-2 mt-2 mt-sm-0"> <input id="radio-switch-5" class="form-check-input" onChange={(e) => setType(e.target.value)} checked={type === "general"} type="radio" name="horizontal_radio_button" value="general" /> <label class="form-check-label" for="radio-switch-5">General</label> </div>
                                            </div>
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Driver <span className="text-theme-6">*</span> :</label>
                                            <Select
                                                styles={styleSelect}
                                                getOptionLabel={(option) => `${option.driver_name}`}
                                                onChange={(e) => handleChangeDriver(e)}
                                                getOptionValue={(option) => `${option.id}`}
                                                options={drivers && drivers.length > 0 ? drivers : []}
                                            />

                                            {/* <Select styles={styleSelect} getOptionLabel={(option) => `${option.partner_id[1]}`} onChange={(e) => handleChangeDriver(e)}
                                                getOptionValue={(option) => `${option.id}`} options={drivers && drivers.length > 0 ? drivers : []} /> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="text-end mt-5">
                                    <button type="button" onClick={() => navigate('/replacementOfVehicle')} className="btn btn-secondary bg-white w-24 me-1">Back</button>
                                    <button onClick={save} type="button" disabled={loading ? true : false} className="btn btn-primary w-24 ms-2">Save</button>
                                </div>
                            </span>
                    }
                </div>
            </div>
        </React.Fragment>
    )
}
export default AddReplacementOfVehicle;